/**
 * Estados de carga da mesa eletrônica (E74.F3). E201.F2 (GUS-47 com a GUS-220): a falha de carga
 * tem saída, tentar de novo ou voltar aos casos (`FalhaComSaida`, E200.F3), em vez de só o aviso.
 *
 * Mesmo recorte de `LaudoCasoPageStates`: erro, carregando e vazio saem da
 * página para que ela seja layout. Sem isso, as três ramificações somadas às da
 * lista estouram o limite de complexidade do lint — que aqui está certo, porque
 * a página passa a ser difícil de ler.
 */
import { FalhaComSaida } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import type { ExameEletronicoCcbData } from '@/lib/exame_eletronico';

const t = ptBR.mesaEletronica;

export interface MesaEletronicaEstadoProps {
  erroGlobal: string | null;
  ccbs: ExameEletronicoCcbData[] | null;
  /** Relê a mesa depois da falha de carga. */
  onTentarDeNovo: () => void;
  /** A nova tentativa está em curso: o botão espera. */
  tentando: boolean;
}

export function MesaEletronicaEstado({
  erroGlobal,
  ccbs,
  onTentarDeNovo,
  tentando,
}: MesaEletronicaEstadoProps): JSX.Element | null {
  if (erroGlobal !== null) {
    return (
      <FalhaComSaida
        className="mt-sc-4 border border-danger bg-danger-50 px-sc-3 py-sc-2"
        mensagem={erroGlobal}
        onTentarDeNovo={onTentarDeNovo}
        tentando={tentando}
        voltar={{ para: '/casos', rotulo: ptBR.falhaComSaida.voltarAosCasos }}
        data-testid="mesa-eletronica-error"
      />
    );
  }
  if (ccbs === null) {
    return (
      <p className="mt-sc-6 text-body-md text-fg-muted" data-testid="mesa-eletronica-loading">
        {t.loading}
      </p>
    );
  }
  if (ccbs.length === 0) {
    return (
      <p className="mt-sc-6 text-body-md text-fg-muted" data-testid="mesa-eletronica-sem-ccbs">
        {t.semCcbs}
      </p>
    );
  }
  return null;
}
